import QuestionMark from '../src/QuestionMark/index.tsx';
export default QuestionMark;
